var map = {
	"./coa/ad.svg": 2183,
	"./coa/ae.svg": 9382,
	"./coa/af.svg": 5605,
	"./coa/ag.svg": 7588,
	"./coa/ai.svg": 7138,
	"./coa/al.svg": 9999,
	"./coa/am.svg": 5710,
	"./coa/ao.svg": 972,
	"./coa/aq.svg": 8650,
	"./coa/ar.svg": 4649,
	"./coa/at.svg": 6855,
	"./coa/au.svg": 966,
	"./coa/aw.svg": 8996,
	"./coa/ax.svg": 6035,
	"./coa/az.svg": 4737,
	"./coa/ba.svg": 8087,
	"./coa/bb.svg": 6580,
	"./coa/bd.svg": 6234,
	"./coa/be.svg": 8203,
	"./coa/bf.svg": 6840,
	"./coa/bg.svg": 2233,
	"./coa/bh.svg": 2414,
	"./coa/bi.svg": 4991,
	"./coa/bj.svg": 5964,
	"./coa/bm.svg": 3619,
	"./coa/bn.svg": 7520,
	"./coa/bo.svg": 2321,
	"./coa/bq.svg": 9767,
	"./coa/br.svg": 5172,
	"./coa/bs.svg": 3189,
	"./coa/bt.svg": 8266,
	"./coa/bw.svg": 3849,
	"./coa/by.svg": 1231,
	"./coa/bz.svg": 8556,
	"./coa/ca.svg": 4608,
	"./coa/cd.svg": 5741,
	"./coa/cf.svg": 495,
	"./coa/ch.svg": 9289,
	"./coa/ci.svg": 1368,
	"./coa/ck.svg": 4890,
	"./coa/cl.svg": 5301,
	"./coa/cm.svg": 9668,
	"./coa/cn.svg": 1175,
	"./coa/co.svg": 4054,
	"./coa/cr.svg": 4451,
	"./coa/cu.svg": 412,
	"./coa/cv.svg": 2111,
	"./coa/cw.svg": 1006,
	"./coa/cx.svg": 4089,
	"./coa/cy.svg": 9224,
	"./coa/cz.svg": 8059,
	"./coa/de.svg": 7089,
	"./coa/dj.svg": 5910,
	"./coa/dk.svg": 4887,
	"./coa/dm.svg": 5321,
	"./coa/do.svg": 8027,
	"./coa/dz.svg": 166,
	"./coa/ec.svg": 1868,
	"./coa/ee.svg": 6482,
	"./coa/eg.svg": 4048,
	"./coa/er.svg": 6093,
	"./coa/es.svg": 5084,
	"./coa/et.svg": 1299,
	"./coa/fi.svg": 3507,
	"./coa/fj.svg": 2752,
	"./coa/fk.svg": 8705,
	"./coa/fm.svg": 8639,
	"./coa/fo.svg": 8557,
	"./coa/fr.svg": 424,
	"./coa/ga.svg": 2628,
	"./coa/gb.svg": 839,
	"./coa/gd.svg": 3401,
	"./coa/ge.svg": 8008,
	"./coa/gf.svg": 2395,
	"./coa/gg.svg": 2026,
	"./coa/gh.svg": 5053,
	"./coa/gi.svg": 5580,
	"./coa/gl.svg": 4257,
	"./coa/gm.svg": 8720,
	"./coa/gn.svg": 5763,
	"./coa/gp.svg": 565,
	"./coa/gq.svg": 9396,
	"./coa/gr.svg": 6167,
	"./coa/gt.svg": 7577,
	"./coa/gu.svg": 3336,
	"./coa/gw.svg": 3114,
	"./coa/gy.svg": 7196,
	"./coa/hk.svg": 5819,
	"./coa/hn.svg": 9878,
	"./coa/hr.svg": 6514,
	"./coa/ht.svg": 7324,
	"./coa/hu.svg": 6797,
	"./coa/id.svg": 7583,
	"./coa/ie.svg": 206,
	"./coa/il.svg": 167,
	"./coa/im.svg": 6342,
	"./coa/in.svg": 4565,
	"./coa/iq.svg": 8898,
	"./coa/ir.svg": 5617,
	"./coa/is.svg": 9664,
	"./coa/it.svg": 5551,
	"./coa/je.svg": 1027,
	"./coa/jm.svg": 5611,
	"./coa/jo.svg": 5929,
	"./coa/jp.svg": 4494,
	"./coa/ke.svg": 6244,
	"./coa/kg.svg": 8214,
	"./coa/kh.svg": 1985,
	"./coa/ki.svg": 7184,
	"./coa/km.svg": 5628,
	"./coa/kn.svg": 4655,
	"./coa/kp.svg": 3513,
	"./coa/kr.svg": 3195,
	"./coa/kw.svg": 6630,
	"./coa/ky.svg": 7872,
	"./coa/kz.svg": 8611,
	"./coa/la.svg": 293,
	"./coa/lb.svg": 1158,
	"./coa/lc.svg": 8695,
	"./coa/li.svg": 9789,
	"./coa/lk.svg": 1775,
	"./coa/lr.svg": 3718,
	"./coa/ls.svg": 3220,
	"./coa/lt.svg": 1032,
	"./coa/lu.svg": 8953,
	"./coa/lv.svg": 4554,
	"./coa/ly.svg": 5405,
	"./coa/ma.svg": 1302,
	"./coa/mc.svg": 6916,
	"./coa/md.svg": 9979,
	"./coa/me.svg": 2138,
	"./coa/mg.svg": 8616,
	"./coa/mh.svg": 1391,
	"./coa/mk.svg": 8716,
	"./coa/ml.svg": 6995,
	"./coa/mm.svg": 9058,
	"./coa/mn.svg": 4097,
	"./coa/mo.svg": 1856,
	"./coa/mq.svg": 8742,
	"./coa/mr.svg": 7877,
	"./coa/ms.svg": 3156,
	"./coa/mt.svg": 5307,
	"./coa/mu.svg": 6250,
	"./coa/mv.svg": 1337,
	"./coa/mw.svg": 6472,
	"./coa/mx.svg": 9359,
	"./coa/my.svg": 8254,
	"./coa/mz.svg": 7373,
	"./coa/na.svg": 3107,
	"./coa/nc.svg": 4833,
	"./coa/ne.svg": 3855,
	"./coa/ng.svg": 77,
	"./coa/ni.svg": 7419,
	"./coa/nl.svg": 7414,
	"./coa/no.svg": 7701,
	"./coa/np.svg": 3586,
	"./coa/nr.svg": 6304,
	"./coa/nz.svg": 7208,
	"./coa/om.svg": 5416,
	"./coa/pa.svg": 7177,
	"./coa/pe.svg": 3717,
	"./coa/pf.svg": 4582,
	"./coa/pg.svg": 2119,
	"./coa/ph.svg": 6640,
	"./coa/pk.svg": 7539,
	"./coa/pl.svg": 3500,
	"./coa/ps.svg": 8200,
	"./coa/pt.svg": 2756,
	"./coa/pw.svg": 4263,
	"./coa/py.svg": 9937,
	"./coa/qa.svg": 5562,
	"./coa/ro.svg": 7761,
	"./coa/rs.svg": 7477,
	"./coa/ru.svg": 7195,
	"./coa/rw.svg": 7673,
	"./coa/sa.svg": 5840,
	"./coa/sb.svg": 6595,
	"./coa/sc.svg": 1426,
	"./coa/sd.svg": 1645,
	"./coa/se.svg": 2700,
	"./coa/sg.svg": 3294,
	"./coa/si.svg": 8840,
	"./coa/sk.svg": 8618,
	"./coa/sl.svg": 6069,
	"./coa/sm.svg": 4900,
	"./coa/sn.svg": 8023,
	"./coa/so.svg": 3638,
	"./coa/sr.svg": 1267,
	"./coa/ss.svg": 6626,
	"./coa/st.svg": 557,
	"./coa/sv.svg": 111,
	"./coa/sy.svg": 3512,
	"./coa/td.svg": 1808,
	"./coa/tf.svg": 7858,
	"./coa/tg.svg": 8851,
	"./coa/th.svg": 5716,
	"./coa/tj.svg": 102,
	"./coa/tm.svg": 6489,
	"./coa/tn.svg": 5114,
	"./coa/to.svg": 5483,
	"./coa/tr.svg": 878,
	"./coa/tt.svg": 3424,
	"./coa/tv.svg": 9010,
	"./coa/tw.svg": 4179,
	"./coa/tz.svg": 1222,
	"./coa/ua.svg": 9134,
	"./coa/ug.svg": 1667,
	"./coa/us.svg": 1804,
	"./coa/uy.svg": 742,
	"./coa/uz.svg": 3701,
	"./coa/va.svg": 1627,
	"./coa/vc.svg": 5657,
	"./coa/ve.svg": 7863,
	"./coa/vg.svg": 1285,
	"./coa/vn.svg": 9388,
	"./coa/vu.svg": 3191,
	"./coa/ws.svg": 7478,
	"./coa/xk.svg": 955,
	"./coa/ye.svg": 3758,
	"./coa/za.svg": 831,
	"./coa/zm.svg": 3067,
	"./coa/zw.svg": 6689,
	"./flag/ad.svg": 8364,
	"./flag/ae.svg": 8077,
	"./flag/af.svg": 8958,
	"./flag/ag.svg": 3711,
	"./flag/ai.svg": 5689,
	"./flag/al.svg": 7508,
	"./flag/am.svg": 8581,
	"./flag/ao.svg": 631,
	"./flag/aq.svg": 8449,
	"./flag/ar.svg": 3410,
	"./flag/as.svg": 7699,
	"./flag/at.svg": 3068,
	"./flag/au.svg": 3693,
	"./flag/aw.svg": 2095,
	"./flag/ax.svg": 2968,
	"./flag/az.svg": 6490,
	"./flag/ba.svg": 7752,
	"./flag/bb.svg": 3291,
	"./flag/bd.svg": 3573,
	"./flag/be.svg": 5588,
	"./flag/bf.svg": 151,
	"./flag/bg.svg": 6934,
	"./flag/bh.svg": 705,
	"./flag/bi.svg": 9584,
	"./flag/bj.svg": 8979,
	"./flag/bl.svg": 9597,
	"./flag/bm.svg": 1052,
	"./flag/bn.svg": 3375,
	"./flag/bo.svg": 3326,
	"./flag/bq.svg": 3080,
	"./flag/br.svg": 1147,
	"./flag/bs.svg": 7274,
	"./flag/bt.svg": 4453,
	"./flag/bv.svg": 8007,
	"./flag/bw.svg": 2678,
	"./flag/by.svg": 5824,
	"./flag/bz.svg": 6835,
	"./flag/ca.svg": 5711,
	"./flag/cc.svg": 4045,
	"./flag/cd.svg": 5522,
	"./flag/cf.svg": 8240,
	"./flag/cg.svg": 2625,
	"./flag/ch.svg": 5094,
	"./flag/ci.svg": 423,
	"./flag/ck.svg": 6869,
	"./flag/cl.svg": 9690,
	"./flag/cm.svg": 3563,
	"./flag/cn.svg": 5496,
	"./flag/co.svg": 857,
	"./flag/cr.svg": 3468,
	"./flag/cu.svg": 1395,
	"./flag/cv.svg": 2000,
	"./flag/cw.svg": 3121,
	"./flag/cx.svg": 9350,
	"./flag/cy.svg": 2567,
	"./flag/cz.svg": 8004,
	"./flag/de.svg": 7562,
	"./flag/dj.svg": 4237,
	"./flag/dk.svg": 4764,
	"./flag/dm.svg": 306,
	"./flag/do.svg": 7904,
	"./flag/dz.svg": 5325,
	"./flag/ec.svg": 4119,
	"./flag/ee.svg": 9177,
	"./flag/eg.svg": 5675,
	"./flag/eh.svg": 8796,
	"./flag/er.svg": 4966,
	"./flag/es.svg": 8791,
	"./flag/et.svg": 9608,
	"./flag/fi.svg": 7844,
	"./flag/fj.svg": 967,
	"./flag/fk.svg": 3430,
	"./flag/fm.svg": 1160,
	"./flag/fo.svg": 7290,
	"./flag/fr.svg": 2431,
	"./flag/ga.svg": 1907,
	"./flag/gb.svg": 5808,
	"./flag/gd.svg": 4350,
	"./flag/ge.svg": 6927,
	"./flag/gf.svg": 4252,
	"./flag/gg.svg": 6445,
	"./flag/gh.svg": 8170,
	"./flag/gi.svg": 139,
	"./flag/gl.svg": 6838,
	"./flag/gm.svg": 6375,
	"./flag/gn.svg": 4868,
	"./flag/gp.svg": 6658,
	"./flag/gq.svg": 7235,
	"./flag/gr.svg": 6496,
	"./flag/gs.svg": 7057,
	"./flag/gt.svg": 1582,
	"./flag/gu.svg": 9519,
	"./flag/gw.svg": 5949,
	"./flag/gy.svg": 5467,
	"./flag/hk.svg": 8576,
	"./flag/hm.svg": 1406,
	"./flag/hn.svg": 4381,
	"./flag/hr.svg": 6521,
	"./flag/ht.svg": 2903,
	"./flag/hu.svg": 9686,
	"./flag/id.svg": 9188,
	"./flag/ie.svg": 4821,
	"./flag/il.svg": 988,
	"./flag/im.svg": 1613,
	"./flag/in.svg": 7438,
	"./flag/io.svg": 15,
	"./flag/iq.svg": 3609,
	"./flag/ir.svg": 4874,
	"./flag/is.svg": 7579,
	"./flag/it.svg": 5428,
	"./flag/je.svg": 7516,
	"./flag/jm.svg": 4564,
	"./flag/jo.svg": 5302,
	"./flag/jp.svg": 8225,
	"./flag/ke.svg": 3627,
	"./flag/kg.svg": 4105,
	"./flag/kh.svg": 3662,
	"./flag/ki.svg": 6092,
	"./flag/km.svg": 9315,
	"./flag/kn.svg": 9920,
	"./flag/kp.svg": 3014,
	"./flag/kr.svg": 3892,
	"./flag/kw.svg": 2425,
	"./flag/ky.svg": 3631,
	"./flag/kz.svg": 4604,
	"./flag/la.svg": 4686,
	"./flag/lb.svg": 6781,
	"./flag/lc.svg": 4588,
	"./flag/li.svg": 7174,
	"./flag/lk.svg": 5204,
	"./flag/lr.svg": 6285,
	"./flag/ls.svg": 828,
	"./flag/lt.svg": 7571,
	"./flag/lu.svg": 6994,
	"./flag/lv.svg": 7393,
	"./flag/ly.svg": 9238,
	"./flag/ma.svg": 7434,
	"./flag/mc.svg": 2271,
	"./flag/md.svg": 9248,
	"./flag/me.svg": 9809,
	"./flag/mf.svg": 5762,
	"./flag/mg.svg": 9987,
	"./flag/mh.svg": 9860,
	"./flag/mk.svg": 4455,
	"./flag/ml.svg": 9384,
	"./flag/mm.svg": 4889,
	"./flag/mn.svg": 2954,
	"./flag/mo.svg": 8219,
	"./flag/mp.svg": 7004,
	"./flag/mq.svg": 9197,
	"./flag/mr.svg": 7102,
	"./flag/ms.svg": 9679,
	"./flag/mt.svg": 8560,
	"./flag/mu.svg": 7009,
	"./flag/mv.svg": 5266,
	"./flag/mw.svg": 4659,
	"./flag/mx.svg": 7620,
	"./flag/my.svg": 2549,
	"./flag/mz.svg": 9590,
	"./flag/na.svg": 9524,
	"./flag/nc.svg": 3910,
	"./flag/ne.svg": 1224,
	"./flag/nf.svg": 2587,
	"./flag/ng.svg": 4746,
	"./flag/ni.svg": 1324,
	"./flag/nl.svg": 6705,
	"./flag/no.svg": 1666,
	"./flag/np.svg": 485,
	"./flag/nr.svg": 8887,
	"./flag/nu.svg": 9080,
	"./flag/nz.svg": 1967,
	"./flag/om.svg": 4383,
	"./flag/pa.svg": 610,
	"./flag/pe.svg": 2478,
	"./flag/pf.svg": 829,
	"./flag/pg.svg": 1884,
	"./flag/ph.svg": 8763,
	"./flag/pk.svg": 8024,
	"./flag/pl.svg": 7207,
	"./flag/pm.svg": 2822,
	"./flag/pn.svg": 5253,
	"./flag/pr.svg": 8945,
	"./flag/ps.svg": 3408,
	"./flag/pt.svg": 9295,
	"./flag/pw.svg": 268,
	"./flag/py.svg": 3066,
	"./flag/qa.svg": 3793,
	"./flag/re.svg": 196,
	"./flag/ro.svg": 4670,
	"./flag/rs.svg": 1258,
	"./flag/ru.svg": 7956,
	"./flag/rw.svg": 9926,
	"./flag/sa.svg": 6879,
	"./flag/sb.svg": 7852,
	"./flag/sc.svg": 7325,
	"./flag/sd.svg": 3394,
	"./flag/se.svg": 8035,
	"./flag/sg.svg": 6529,
	"./flag/sh.svg": 5638,
	"./flag/si.svg": 9463,
	"./flag/sj.svg": 2519,
	"./flag/sk.svg": 7509,
	"./flag/sl.svg": 650,
	"./flag/sm.svg": 1019,
	"./flag/sn.svg": 280,
	"./flag/so.svg": 2025,
	"./flag/sr.svg": 9468,
	"./flag/ss.svg": 8413,
	"./flag/st.svg": 8194,
	"./flag/sv.svg": 2608,
	"./flag/sx.svg": 406,
	"./flag/sy.svg": 4791,
	"./flag/sz.svg": 1668,
	"./flag/tc.svg": 2487,
	"./flag/td.svg": 7019,
	"./flag/tf.svg": 6697,
	"./flag/tg.svg": 1832,
	"./flag/th.svg": 4719,
	"./flag/tj.svg": 9085,
	"./flag/tk.svg": 9372,
	"./flag/tl.svg": 7059,
	"./flag/tm.svg": 4418,
	"./flag/tn.svg": 8961,
	"./flag/to.svg": 2512,
	"./flag/tr.svg": 7909,
	"./flag/tt.svg": 5339,
	"./flag/tv.svg": 8249,
	"./flag/tw.svg": 3976,
	"./flag/tz.svg": 4701,
	"./flag/ua.svg": 469,
	"./flag/ug.svg": 811,
	"./flag/um.svg": 4929,
	"./flag/us.svg": 2375,
	"./flag/uy.svg": 6621,
	"./flag/uz.svg": 2254,
	"./flag/va.svg": 4476,
	"./flag/vc.svg": 6750,
	"./flag/ve.svg": 3008,
	"./flag/vg.svg": 9090,
	"./flag/vi.svg": 9012,
	"./flag/vn.svg": 6715,
	"./flag/vu.svg": 6867,
	"./flag/wf.svg": 108,
	"./flag/ws.svg": 6545,
	"./flag/xk.svg": 1328,
	"./flag/ye.svg": 5589,
	"./flag/yt.svg": 7652,
	"./flag/za.svg": 5264,
	"./flag/zm.svg": 5239,
	"./flag/zw.svg": 3278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4509;